<template>
  <div class="month">
    <div class="monthName">
      <h2>{{ month }}</h2>
    </div>
    <div class="days-of-week">
      <p>Sun</p>
      <p>Mon</p>
      <p>Tue</p>
      <p>Wed</p>
      <p>Thr</p>
      <p>Fri</p>
      <p>Sat</p>
    </div>
    <div class="days">
      <!-- <div
        class="name-of-month body big"
        :class="[rightAlign ? 'right-align' : '']"
        :style="monthStyles"
      >
        <span></span>
      </div> -->
      <div
        class="day"
        :class="[
          plan == `Full Season`,
          day.hide ? 'hide' : '',
          day.opponent ? 'has-opponent' : '',
          day.opponentInPlan ? 'has-opponent-in-plan' : '',
        ]"
        v-for="(day, index) in daysVisible"
        :style="{
          'grid-column-start': day.dayOfWeek,
          'grid-row-start': day.weekOfMonth,
          'background-color': day.color,
        }"
        :key="index"
      >
        <div class="day-in-month">{{ day.dayOfMonth }}</div>
        <div class="opponent" v-if="day.opponent">{{ day.opponent }}</div>
        <div class="time" v-if="day.time">{{ day.time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Month",
  props: {
    startDate: String,
    endDate: String,
    month: String,
    rightAlign: Boolean,
    showOnly: {
      default: "",
      type: String,
    },
    stopAfter: {
      default: "",
      type: String,
    },
    monthEndColumn: {
      // default: 2,
      type: Number,
    },
    monthStartRow: {
      // default: 0,
      type: Number,
    },
    monthStartColumn: {
      // default: 0,
      type: Number,
    },
    games: Array,
    plan: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      monthStyles: {
        "grid-column-start": this.monthStartColumn,
        "grid-column-end": this.monthEndColumn,
        "grid-row-start": this.monthStartRow,
      },
      planMapping: {
        wd: "Weekday Plan",
        we: "Weekend Plan",
        fr: "Friday Plan",
        st: "Saturday Plan",
        su: "Sunday Plan",
      },
    };
  },
  mounted() {},
  computed: {
    showMonth() {
      if (this.showOnly !== "") {
        const date = moment(this.showOnly);
        return date;
      }
      return null;
    },
    stopAfterDay() {
      if (this.stopAfter !== "") {
        const date = moment(this.stopAfter);
        return date;
      }
      return null;
    },
    daysVisible() {
      const startDate = moment(this.startDate).startOf("week");
      const endDate = moment(this.endDate).endOf("week");
      let days = [];
      while (startDate < endDate) {
        let game = this.games.find(
          (game) => game.date === startDate.format("MMMM D YYYY")
        );
        let opponent;
        let gameDate;
        let time;
        let color = "#fff";
        let opponentInPlan = false;
        if (game) {
          opponent = game.opponent;
          time = game.time;
          gameDate = game.date;
          color = "#AFB4BD";

          if (
            this.plan === "Full Season" ||
            game.plans?.some((p) => this.planMapping[p] === this.plan)
          ) {
            opponentInPlan = true;
            color = "#002962";
          }
        }

        let specialCase = false; //July 31 needs to show up on the august calendar
        let addDay = false;
        if (
          this.month === "August" &&
          startDate.format("MMMM D") === "July 31"
        ) {
          specialCase = true;
          addDay = true;
        } else if (this.showOnly === "" && this.stopAfter === "") {
          addDay = true;
        } else {
          if (
            this.showOnly !== "" &&
            startDate.format("M") === this.showMonth.format("M")
          ) {
            addDay = true;
          }
          if (this.stopAfter !== "" && startDate <= this.stopAfterDay) {
            addDay = true;
          }
        }

        if (addDay) {
          let dayOfMonth = startDate.format("D");
          if (specialCase) {
            color = "#FFF";
            dayOfMonth = "";
          }
          days.push({
            gameDate: gameDate,
            dayOfMonth: dayOfMonth,
            dayOfWeek: 1 + parseInt(startDate.format("d")),
            weekOfMonth: 1 + parseInt(days.length / 7),
            opponent,
            time,
            opponentInPlan: opponentInPlan,
            color: color,
          });
        } else {
          days.push({
            timestamp: startDate.format("X"),
            dayOfWeek: 1 + parseInt(startDate.format("d")),
            weekOfMonth: 1 + parseInt(days.length / 7),
            hide: true,
            color: "#FFF",
          });
        }
        startDate.add(1, "days");
      }
      return days;
    },
  },
  methods: {
    getOpponent(date) {
      return this.games.filter((game) => game.date === date);
    },
  },
};
</script>

<style lang="scss" scoped>
.month {
  //background:#FFF;
  //padding:2px;
  /* border: 1px solid transparent; */
  /* background: #00285e; */
  background: white;
  /* box-sizing: border-box; */
  width: 100%;
  padding: 0.5px;
  //border: 2px solid $light-blue;
  //background: $light-blue;
  .monthName {
    background-color: $light-blue;
    h2 {
      /* body big */

      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 34px;
      /* identical to box height */

      text-align: center;

      /* navy */

      color: #00285e;
    }
  }
}
.days {
  //background:#FFF;
  /* box-sizing: border-box; */
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  //gap:2px;
  width: 100%;
  position: relative;
  //border: 1px solid $light-blue;
  .name-of-month {
    /* border-left: 1px solid $light-blue; */
    grid-column: 1;
    grid-row-start: 1;
    background: #fff;
    height: 35px;
    padding: 1px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    z-index: 1;
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;
    &.right-align span {
      margin-left: auto;
    }
  }
  .day {
    position: relative;
    /* border: 1px solid #fff; */
    background: #e7e6e8;
    height: 35px;
    padding: 1px;
    transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    user-select: none;
    border: 0.5px solid $light-blue;
    &.selected {
      background: #6ad16f !important;
    }
    &.selectable {
      cursor: pointer;
    }
    &.hide {
      opacity: 0;
    }
    .time {
      font-size: 9px;
      text-align: right;
      padding-right: 2px;
    }
    .ssh {
      position: absolute;
      top: 2px;
      right: 2px;
      height: 7px;
    }
    .day-in-month {
      font-size: 6px;
      padding-left: 2px;
      line-height: 10px;
    }
    .opponent {
      font-size: 10px;
      text-align: center;
      line-height: 18px;
      position: relative;
      top: -4px;
      font-weight: 900;
    }
    .time {
      font-size: 9px;
      text-align: center;
      line-height: 5px;
      position: relative;
      top: -4px;
    }
    &.has-opponent {
      background: #afb4bd;
      color: #fff;
    }
    &.has-opponent-in-plan {
      background: #002962;
    }
  }
}
.days-of-week {
  width: 100%;
  background: #002962;
  font-family: "Futura";
  font-style: normal;
  font-weight: 500;
  line-height: 15px;
  color: #fff;
  text-transform: uppercase;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-size: 7px;

  //margin-bottom: 2px;
  p {
    padding-top: 0;
    margin-top: 1px;
    border-right: 1px solid $light-blue;
    &:last-child {
      border-right: none;
    }
  }
}
</style>